type GetLaneAddressProps = {
  city?: string
  state?: string
  zipcode?: string
}

export function getLaneDescription({ city, state, zipcode }: GetLaneAddressProps) {
  return [city, state, zipcode].filter(Boolean).join(', ')
}
